
<div class="network-container">
  <table>
    <tbody>
      <tr>
        <td colspan="4">
          <span class="form-label">&#9679; {{ getMainVehicleLabel() }}:</span>
        </td>
      </tr>
    </tbody>

    <tbody>
      @for (accessory of vehicleData.vehicle.accessories; track accessory.id) {
          <tr>
            <td class="primeiracoluna"></td>
            <td><span class="form-label">&#9679; {{ accessory.name }}:</span></td>
            <td><span class="form-readonly">{{ formatAccessoryValue(accessory.value) }}</span></td>
            @if (shouldShowActionButton(accessory)) {
              <td class="coluna-botao">
                <button
                  type="button"
                  class="accessory-action-button"
                  [disabled]="isLoading(accessory)"
                  [attr.aria-pressed]="isAccessoryActive(accessory)"
                  (click)="toggleAccessory(accessory)"
                  (keydown.enter)="toggleAccessory(accessory)"
                  (keydown.space)="toggleAccessory(accessory)">
                  {{ getActionLabel(accessory) }}
                </button>
              </td>
              <td class="coluna-loading">
                @if (isLoading(accessory)) {
                  <span class="loading-spinner"></span>
                }
                @if (!isTransitioning(accessory) && getErrorMessage(accessory)) {
                  <span class="accessory-error-message" role="alert">{{ getErrorMessage(accessory) }}</span>
                }
              </td>
            }
          </tr>
        }
    </tbody>

    @for (trailer of vehicleData.couplings; track trailer.id; let trailerIdx = $index) {
      <tbody>
        <tr>
          <td colspan="3">
            <span class="form-label">&#9679; {{ getTrailerIdentifierLabel() }}:</span> <span class="form-readonly-inline">{{ trailer.plate }}</span>
          </td>
        </tr>

        @for (accessory of trailer.accessories; track accessory.id) {
          <tr>
            <td class="primeiracoluna"></td>
            <td><span class="form-label">&#9679; {{ accessory.name }}:</span></td>
            <td>
              @if (accessory.type == 'engate') {
                <span class="form-readonly">{{ accessory.position }}</span>
              } @else {
                <span class="form-readonly">{{ formatAccessoryValue(accessory.value) }}</span>
              }
            </td>
            @if (shouldShowActionButton(accessory)) {
              <td class="coluna-botao">
                <button
                  type="button"
                  class="accessory-action-button"
                  [disabled]="isLoading(accessory)"
                  [attr.aria-pressed]="isAccessoryActive(accessory)"
                  (click)="toggleAccessory(accessory)"
                  (keydown.enter)="toggleAccessory(accessory)"
                  (keydown.space)="toggleAccessory(accessory)">
                  {{ getActionLabel(accessory) }}
                </button>
              </td>
              <td class="coluna-loading">
                @if (isLoading(accessory)) {
                  <span class="loading-spinner"></span>
                }
                @if (!isTransitioning(accessory) && getErrorMessage(accessory)) {
                  <span class="accessory-error-message" role="alert">{{ getErrorMessage(accessory) }}</span>
                }
              </td>
            }
          </tr>
        }
    }
  </table>
</div>